import { Badge, Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const CarrierCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}>
            <Text>{rowData.carrier}</Text>
            {rowData.upstreamCarrier !== rowData.carrier ? (
                <Badge size={'sm'}>{rowData.upstreamCarrier}</Badge>
            ) : (
                <Badge
                    size={'sm'}
                    color={'gray'}>
                    Non-MVNO
                </Badge>
            )}
        </Box>
    );
};

const CarrierColumn = () => ({
    accessorKey: 'carrier',
    header: 'Carrier',
    size: 1,
    Cell: ({ cell }) => <CarrierCell cell={cell} />,
});
export default CarrierColumn;
